export default {
  index: 'main',
  name: 'Панорама',
  image: require('@/assets/images/panorama/pano.jpeg'),
  center: {
    x: 6730,
    y: 2090
  },
  polarAngle: {
    min: 1.5,
    max: 1.6
  },
  endPoints: [
    {
      label: 'Дмитровское шоссе',
      type: 'label',
      category: 'окружение, удобство, гармония, развитие, семья',
      position: {
        x: 7790,
        y: 2020
      }
    },
    // {
    //   label: 'Ленинградское шоссе',
    //   type: 'label',
    //   category: 'окружение, развитие',
    //   position: {
    //     x: 50,
    //     y: 10
    //   }
    // },
    {
      label: 'Ленинградское шоссе',
      type: 'label',
      category: 'окружение, развитие',
      position: {
        x: 2800,
        y: 2050
      }
    },
    {
      label: 'Коптевская улица',
      type: 'label',
      category: 'окружение, удобство, гармония, развитие, семья',
      position: {
        x: 790,
        y: 2510
      }
    },
    {
      label: 'школа №1223',
      icon: 'book',
      category: 'окружение, семья',
      position: {
        x: 6890,
        y: 2180
      }
    },
    {
      label: 'Детский сад № 2742 ',
      icon: 'kinder',
      category: 'окружение, семья',
      position: {
        x: 7130,
        y: 2200
      }
    },
    {
      label: 'Детский сад № 426',
      icon: 'kinder',
      category: 'окружение, семья',
      position: {
        x: 6750,
        y: 2170
      }
    },
    {
      label: 'Do not touch this object',
      icon: 'You have not seen it',
      category: 'окружение, удобство, гармония, развитие, семья',
      position: {
        x: 6000,
        y: 2000
      }
    },
    {
      label: 'МЦК Коптево',
      icon: 'metro',
      category: 'окружение, удобство, гармония, развитие, семья',
      position: {
        x: 6150,
        y: 2225
      }
    },
    {
      label: 'Городская поликлиника №142',
      icon: 'caseCross',
      category: 'окружение, удобство',
      position: {
        x: 7250,
        y: 2260
      }
    },
    {
      label: 'Аптека',
      icon: 'health',
      category: 'окружение, удобство',
      position: {
        x: 7470,
        y: 2490
      }
    },
    {
      label: 'Останкинская телебашня',
      icon: 'tower',
      category: 'окружение',
      position: {
        x: 7975,
        y: 1960
      }
    },
    {
      label: 'школа №90',
      icon: 'book',
      category: 'окружение, семья',
      position: {
        x: 8140,
        y: 2205
      }
    },
    {
      label: 'Детская поликлиника №15',
      icon: 'caseCross',
      category: 'окружение, удобство',
      position: {
        x: 200,
        y: 2260
      }
    },
    {
      label: 'Супермаркет',
      icon: 'shop',
      category: 'окружение',
      position: {
        x: 350,
        y: 2310
      }
    },
    {
      label: 'Тимирязевский парк',
      icon: 'forest',
      category: 'окружение, гармония',
      position: {
        x: 350,
        y: 2110
      }
    },
    {
      label: 'Семейный парк «Московские сезоны»',
      icon: 'forest',
      category: 'окружение, гармония',
      position: {
        x: 785,
        y: 2255
      }
    },
    {
      label: 'Коптевский фермерский рынок',
      icon: 'shop',
      category: 'окружение',
      position: {
        x: 730,
        y: 2360
      }
    },
    {
      label: 'Скейт-парк',
      icon: 'fitness',
      category: 'окружение',
      position: {
        x: 930,
        y: 2300
      }
    },
    {
      label: 'Площадка для мини-футбола',
      icon: 'fitness',
      category: 'окружение',
      position: {
        x: 1010,
        y: 2300
      }
    },
    {
      label: 'ТЦ Метрополис',
      icon: 'TRC',
      category: 'окружение, удобство',
      position: {
        x: 2540,
        y: 2097
      }
    },
    {
      label: 'Парк у Головинских прудов',
      icon: 'forest',
      category: 'окружение, гармония',
      position: {
        x: 5270,
        y: 2170
      }
    },
    {
      label: 'Усадьба Михалково',
      icon: 'forest',
      category: 'окружение, гармония',
      position: {
        x: 5390,
        y: 2195
      }
    },
    {
      label: 'Офис продаж',
      icon: 'officeOne',
      backgroundColor: '#E5E5E5',
      category: 'окружение',
      position: {
        x: 3513,
        y: 2197
      }
    },
    {
      label: 'м. Водный стадион',
      icon: 'metroVodnii',
      category: 'окружение, удобство, гармония, развитие, семья',
      position: {
        x: 3778,
        y: 2114
      }
    }
    // {
    //   label: 'Север',
    //   type: 'label',
    //   category: 'окружение, удобство, гармония, развитие, семья',
    //   position: {
    //     x: 5750,
    //     y: 1950
    //   }
    // }
  ]
}
